<template>
    <v-app>
        <Header v-if="!loading" :dark="dark" :background-color="backgroundColor" :id_chatbot="idChatBot" />
        <v-main app v-if="!loading">
            <div v-if="conversations.length > 0">
                <div v-for="(item) in conversations" :key="item.id_session">
                    <v-card style="height: fit-content; border-radius: 15px;" elevation="0" outlined
                        class="mt-3 ml-1 mr-1 pa-2" @click="goToSession(item.id_session)">
                        <v-list-item>
                            <!-- Avatar circular con logo -->
                            <v-list-item-avatar>
                                <v-avatar size="45">
                                    <img :src="urlLogo" alt="Avatar" />
                                </v-avatar>
                            </v-list-item-avatar>

                            <!-- Contenido del chatbot -->
                            <v-list-item-content>
                                <v-list-item-title class="font-weight-medium">
                                    {{ getTruncatedMessage(item.messages) }}
                                </v-list-item-title>
                                <v-list-item-subtitle class="grey--text mt-1">
                                    {{ chatbotName }} • {{ formatDate(item.created_at) }}
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-card>
                </div>
            </div>
            <v-card class="mx-auto my-auto" elevation="0" v-if="conversations.length == 0" style="text-align: center; padding-top: 50px;">
                <v-icon x-large class="ma-5">mdi-alert-circle-outline</v-icon>
                <p>No recent chats found</p>
                <v-btn rounded :color="backgroundColor" :dark="dark" class="white--text" @click="goToNewChat()"><v-icon left >mdi-plus</v-icon>Start a new chat</v-btn>
            </v-card>
        </v-main>
        
        <v-progress-circular class="mx-auto my-auto" indeterminate color="black" size="40" v-if="loading"></v-progress-circular>
    </v-app>
</template>

<script>
import Header from '../components/recentChatsComponents/chatHeader.vue'
import axiosChat from "@/logic/B2C/register_chats_chatpro/axiosChat.js";


export default {
    name: 'ChatView',
    components: {
        Header
    },

    data() {
        return {
            //get from url id
            urlLogo: "",
            chatbotName: "",
            backgroundColor: "",
            dark: true,
            idChatBot: "",
            loading: true,
            conversations: []
        }
    },

    watch: {
        pageTitle(newTitle) {
            document.title = newTitle || 'Powered by ChatPro AI';
        }
    },

    async mounted() {
        this.loading = true //activa el loader
        this.idChatBot = this.$route.params.idChatbot

        const responseGetDataChatbot = await axiosChat.get_data_chatbot(this.$route.params.idChatbot)
        if (responseGetDataChatbot.data.code == "success" & responseGetDataChatbot.data.data != undefined) {
            //chatbot data
            // console.log("Chatbot data", responseGetDataChatbot.data.data);
            this.urlLogo = responseGetDataChatbot.data.data.url_logo;
            this.chatbotName = responseGetDataChatbot.data.data.chatbot_name;

            this.backgroundColor = responseGetDataChatbot.data.data.background_color_1;
            this.dark = responseGetDataChatbot.data.data.dark_1;
            this.backgroundColor2 = responseGetDataChatbot.data.data.background_color_2;
            this.dark2 = responseGetDataChatbot.data.data.dark_2;
            this.language = responseGetDataChatbot.data.data.language; //  🇺🇸 EN  🇪🇸 ES
            this.idUser = responseGetDataChatbot.data.data.id_user;
            this.initialPrompt = responseGetDataChatbot.data.data.initial_prompt;
            this.createdAt = responseGetDataChatbot.data.data.created_at;
            this.privateChatbot = responseGetDataChatbot.data.data.private;
            this.suggestedMessages = [...(responseGetDataChatbot.data.data.suggested_messages || [])]
            this.welcomeMessage = responseGetDataChatbot.data.data.welcome_message || "Hi, how can I help you?👋"

            //Favicon and Tab Name
            this.pageTitle = responseGetDataChatbot.data.data.chatbot_name + ' | Powered by ChatPro AI';
            this.updateFavicon(responseGetDataChatbot.data.data.url_logo);

            

            const ref = this.getRefSession()

            if (ref == null) {
                console.log("No ref_session found")
                this.loading = false

            }
            else {
                this.getConversationsCookie(ref)
            }
        }
        else {
            //// console.log('error ó chatbot desconocido')
        }


    },


    methods: {
        formatDate(isoDate) {
            const date = new Date(isoDate);
            return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
        },
        getTruncatedMessage(messages) {
            const lastMsg = messages
                .filter(m => m.uid === '001')
                .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))[0];
            if (!lastMsg) return '';
            return lastMsg.content.length > 45
                ? lastMsg.content.slice(0, 42) + '...'
                : lastMsg.content;
        },

        goToSession(id) {
            this.$router.push('/' + this.idChatBot + '/' + id);
        },

        goToNewChat() {
            this.$router.push('/' + this.idChatBot);
        },

        updateFavicon(logoUrl) {
            const faviconUrl = logoUrl || 'https://d7nzzuxaahac2.cloudfront.net/web/generic_logo_chatpro_bot_purple.webp';

            // Eliminar favicon existente
            const existingFavicon = document.querySelector('link[rel="icon"]');
            if (existingFavicon) {
                existingFavicon.parentNode.removeChild(existingFavicon);
            }

            // Crear y agregar nuevo favicon
            const favicon = document.createElement('link');
            favicon.rel = 'icon';
            favicon.type = 'image/png';
            favicon.href = faviconUrl;
            document.head.appendChild(favicon);

            // console.log(`Favicon actualizado a: ${faviconUrl}`);
        },

        getRefSession() {
            const ref = this.$route.query.session_ref;

            if (!ref) {
                console.warn('Query param "session_ref" is missing or empty');
                return null; // o puedes retornar un valor por defecto
            }

            console.log('Query param Ref:', ref);
            return ref;
        },

        async getConversationsCookie(session_ref) {

            if (session_ref == null) {
                console.log("No ref_session found")
                this.loading = false
            }
            else {
                console.log(session_ref)
                const responseGetDataConversation = await axiosChat.get_conversations_user_cookie(session_ref)
                // console.log(responseGetDataConversation.data.data)
                this.conversations = responseGetDataConversation.data.data
                this.loading = false

            }
        }
    }

}
</script>
